import {
  ShoppingListConnectorApollo,
  ShoppingListMarkProductConnectorApollo,
  ShoppingListOnDemandConnectorApollo,
  ShoppingListPeriodConnectorApollo,
} from '@front-activerse/common-components';
import ShoppingListIndexContainer from './ShoppingListIndexContainer';
import ShoppingListPlaceholder from './Placeholder/ShoppingListPlaceholder';

const ShoppingListPage = ({ shoppingTipsArticleId }) => {
  return (
    <ShoppingListPeriodConnectorApollo>
      {(periodData) => {
        if (periodData.loading) return <ShoppingListPlaceholder />;
        return (
          <ShoppingListConnectorApollo>
            {(shoppingListData) => (
              <ShoppingListOnDemandConnectorApollo>
                {(shoppingListOnDemandData) => (
                  <ShoppingListMarkProductConnectorApollo
                    period={shoppingListOnDemandData.period || periodData.period}
                  >
                    {({ handleMarkProduct }) => (
                      <ShoppingListIndexContainer
                        {...{
                          handleMarkProduct,
                        }}
                        {...shoppingListData}
                        {...shoppingListOnDemandData}
                        {...periodData}
                        loading={shoppingListData.loading || periodData.loading}
                        shoppingTipsArticleId={shoppingTipsArticleId}
                      />
                    )}
                  </ShoppingListMarkProductConnectorApollo>
                )}
              </ShoppingListOnDemandConnectorApollo>
            )}
          </ShoppingListConnectorApollo>
        );
      }}
    </ShoppingListPeriodConnectorApollo>
  );
};

export default ShoppingListPage;
